/**
 * 加入考题本
 */

import {fetchData} from '@umu/umu-fetch';
import Api from '../../../../path';

export interface IInput {
    element_id: number;
    question_id: number;
    element_type?: number;
    _type: number;
}

export interface IOutput {
    status: number;
}

export const addToQuestionCollection = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.ADD_QUESTION_COLLECTION, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};

export const addToQuestionCollectionV2 = (data: IInput): Promise<IOutput> => {
    const input = {
        element_id: data.element_id,
        question_id: data.question_id,
        element_type: data.element_type
    };

    const api = {
        url: data._type === 0 ? Api.ADD_QUESTION_COLLECTION_UAPI.url : Api.QUESTION_COLLECTION_ADD.url,
        type: Api.ADD_QUESTION_COLLECTION.type,
    };

    return fetchData(api, input).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
